import React from "react";
import i18n from "../../../i18n/i18n";
import "./addUser.scss";
import UserForm from "../userForm/userForm";

export default function AddUser() {
    return (
        <div className="add-user">
            <div className="content">
                <div className="header" data-testid="add-user-header">
                    {i18n.t("administration.addUser.header")}
                    <UserForm isUpdate={false} />
                </div>
            </div>
        </div>
    );
}
